import { connect } from 'react-redux';
import { fetchGuestVisits } from '../../../redux/Guest/sagas/routines';
import {
  getFetching,
  getFetched,
  getOrder
} from '../../../redux/Guest/selectors/visit';
import {
  clearGuestVisits,
  guestVisitsOnChangePage,
  guestVisitsOnChangeOrder
} from '../../../redux/Guest/actions/visit';
import {
  getPaginationLoadedPages,
  getPaginationWithoutPages,
  getPaginationQueryOptions,
  getCurrentPageVisits
} from '../../../redux/Guest/selectors/visit/pagination';
import { getGuestVisitSearchQuery } from '../../../redux/Guest/selectors/components/visit-search';
import paginationAndSearchQuery from '../../../helpers/paginationAndSearchQuery';
import GuestVisitList from '../../../components/guest/VisitList';
import orderList from '../../../helpers/orderList';
import {
  fetchVisitColumns,
  fetchVisitConfigs
} from '../../../redux/sagas/visit/routines';
import { getAllVisitConfigs } from '../../../redux/selectors/visit/configs';
import { getVisitCustomFields } from '../../../redux/selectors/visit/columns';

function mapStateToProps(state) {
  const paginationQuery = getPaginationQueryOptions(state);
  const searchQuery = getGuestVisitSearchQuery(state);
  const order = getOrder(state);
  return {
    data: orderList(order, getCurrentPageVisits(state)),
    query: { ...paginationAndSearchQuery(paginationQuery, searchQuery), order },
    loadedPages: getPaginationLoadedPages(state),
    pagination: getPaginationWithoutPages(state),
    isFetching: getFetching(state),
    isFetched: getFetched(state),
    visitConfigs: getAllVisitConfigs(state),
    visitCustomFields: getVisitCustomFields(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      dispatch(fetchVisitConfigs());
      dispatch(fetchVisitColumns());
    },
    onChangePage: (query, isPageLoaded) => {
      const { page } = query;
      if (!isPageLoaded) dispatch(fetchGuestVisits(query));
      else dispatch(guestVisitsOnChangePage(page));
    },
    onChangeLimit: query => {
      dispatch(clearGuestVisits());
      dispatch(fetchGuestVisits(query));
    },
    onSort: (sortBy, sortOrder, query) => {
      const order = `${sortBy}:${sortOrder}`;
      dispatch(clearGuestVisits());
      dispatch(fetchGuestVisits({ ...query, order }));
      dispatch(guestVisitsOnChangeOrder(order));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GuestVisitList);
